import i18n from 'i18next';
import { TranslationCommon } from '@tools/ui-locales';

export const t = (
  key: TranslationCommon,
  values?: Record<string, unknown>
): string => i18n.t<string, TranslationCommon>(key, values);
